import { render, staticRenderFns } from "./GciLink.vue?vue&type=template&id=2897ab42"
import script from "./GciLink.vue?vue&type=script&lang=js"
export * from "./GciLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports